import { donationStatus } from '../../core/constants';

/** The annual donation summary always covers the previous calendar year. */
export const getAnnualSummaryYear = (now = new Date()) => now.getFullYear() - 1;

/**
 * Whether the contact has a succeeded donation created in `year` — used only to decide
 * whether to offer the "email donation summary" action. The server makes the real check
 * against the donation summary table and answers 404 if this guess was wrong (e.g. a
 * donation created on 31 Dec in one timezone and paid on 1 Jan in another).
 *
 * @param {{ status: string, createdAt: number }[]} donations createdAt is in seconds
 * @param {number} year
 */
export const hasSucceededDonationInYear = (donations, year) =>
  (donations || []).some(
    (donation) =>
      donation.status === donationStatus.succeeded && new Date(donation.createdAt * 1000).getFullYear() === year,
  );
